import React from 'react';

import makeStyles from '@mui/styles/makeStyles';
import BasicButton from '../Buttons/BasicButton';

const useStyles = makeStyles(theme => ({
    block: {
        backgroundColor: theme.palette.secondary.main,
        border: "1px solid "+theme.palette.secondary.border,
        display: "flex",
        alignItems: "center",
        textTransform: "none",
        textAlign: "left",
        borderRadius: 0,

        color: "inherit",
        font: "inherit",
        cursor: "pointer",
        "&:hover": {
            borderColor: theme.palette.primary.main,
        },

        "& .block__inner": {
            width: "100%",
        }
    },
}));


export default function ButtonBlock({ children, padding = "1rem 2rem", style = {}, className = '', innerProps = {}, ...props }) {

    const classes = useStyles();

    const blockProps = {
        ...props,
        style: {
            padding: padding != null ? padding : undefined,
            ...style
        },
        className: `${className} ${classes.block} block`,
    }

    const blockInnerProps = {
        ...innerProps,
        className: "block__inner " + innerProps.className,
    }

    return (
        <BasicButton {...blockProps}>
            <div {...blockInnerProps}>
                {children}
            </div>
        </BasicButton>
    );
}